import { messageService } from 'src/app/message.service';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { OverlayModule } from '@angular/cdk/overlay';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TableComponent } from './table/table.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { SuccessSnackbarComponent } from './support/success-snackbar/success-snackbar.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { LeftTreeComponent } from './left-tree/left-tree.component';
import { ManageTrainingComponent } from './manage-training/manage-training.component';
import { AddTrainingComponent } from './add-training/add-training.component';
import { ContentDialogComponent } from './add-training/training-content/training-content.component';
import { AssessmentDialogComponent } from './add-training/content-assessment/content-assessment.component';
import { AssessmentOptionDialogComponent } from './add-training/assessment-option/assessment-option.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { UsersComponent } from './users/users.component';
import { ReorderDialogComponent } from './add-training/reorder-dialog/reorder-dialog.component';
import { MenuItemComponent } from './menu-item/menu-item.component';

import { TrainingPreviewComponent } from './training-preview/training-preview.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginationService } from './PaginationService';
import { TrainingDashboardComponent } from './training-dashboard/training-dashboard.component';
import { LaunchTrainingComponent } from './launch-training/launch-training.component';
import { GroupsComponent } from './dms/groups/groups.component';
import { GroupUsersComponent } from './dms/group-users/group-users.component';
import { CodelistComponent } from './admin/codelist/codelist.component';
import { QuizComponent } from './launch-training/quiz/quiz.component';
import { QuizItemComponent } from './launch-training/quiz-item/quiz-item.component';
import { TrainingParameterTemplateComponent } from './tms/training-parameter-template/training-parameter-template.component';
import { DocumentTemplateComponent } from './dms/document-template/document-template.component';
import { ReasonForSignatureTemplateComponent } from './reason-for-signature-template/reason-for-signature-template.component';
import { TrainingReviewPeriodComponent } from './lms/training-review-period/training-review-period.component';
import { QmsSettingsVwComponent } from './admin/qms-settings-vw/qms-settings-vw.component';
import { TmsSettingsComponent } from './admin/tms-settings/tms-settings.component';
import { DmsSettingsComponent } from './admin/dms-settings/dms-settings.component';
import { ProductCountriesComponent } from './qms/product-countries/product-countries.component';
import { VendorsComponent } from './qms/vendors/vendors.component';
import { ProductMasterComponent } from './qms/product-master/product-master.component';
import { DocumenttypeComponent } from './documenttype/documenttype.component';
import { QmsgroupsComponent } from './qmsgroups/qmsgroups.component';
import { GroupDetailsComponent } from './qmsgroups/group-details/group-details.component';
import { GroupusersComponent } from './qmsgroups/groupusers/groupusers.component';
import { CRComponent } from './qms/cr/cr.component';
import { ActivityDynamicButtonComponent } from './qms/activity-dynamic-button/activity-dynamic-button.component';
import { ActivityGridComponent } from './qms/activity-grid/activity-grid.component';
import { CommonModule, DatePipe } from '@angular/common';
import { TmsGroupsComponent } from './tms/tms-groups/tms-groups.component';
import { TmsGroupDetailComponent } from './tms/tms-groups/tms-group-detail/tms-group-detail.component';
import { TmsGroupUsersComponent } from './tms/tms-groups/tms-group-users/tms-group-users.component';
import { TmsGroupTrainingsComponent } from './tms/tms-groups/tms-group-trainings/tms-group-trainings.component';
import { qmsService } from './qms/qms.service';
import { QmsReportTemplateComponent } from './qms-report-template/qms-report-template.component';
import { QmsReporttemplateSectionfieldComponent } from './qms-reporttemplate-sectionfield/qms-reporttemplate-sectionfield.component';
import { StageusersComponent } from './qms/stageusers/stageusers.component';
import { TrainingDashboardDetailComponent } from './training-dashboard/training-dashboard-detail/training-dashboard-detail.component';
import { TaskDocumentsComponent } from './qms/task-documents/task-documents.component';
import { QmsQuestionnaireTemplateComponent } from './qms-questionnaire-template/qms-questionnaire-template.component';
import { QmsQuestionnaireTemplateQuestionComponent } from './qms-questionnaire-template-question/qms-questionnaire-template-question.component';
import { DmsRootFolderComponent } from './dms-root-folder/dms-root-folder.component';
import { DmsSubFolderComponent } from './dms-sub-folder/dms-sub-folder.component';
import { AddDocumentComponent } from './dms-sub-folder/add-document/add-document.component';
import { OneqmsOrganizationComponent } from './oneqms-organization/oneqms-organization.component';
import { TaskExtensionsComponent } from './qms/task-extensions/task-extensions.component';
import { ActionsComponent } from './qms/actions/actions.component';
import { QmsBusinessareaComponent } from './admin/qms-businessarea/qms-businessarea.component';
import { TasksEcComponent } from './qms/tasks-ec/tasks-ec.component';
import { Idle } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TasksEcActionsComponent } from './qms/tasks-ec-actions/tasks-ec-actions.component';
import { TasksEcParticipantsComponent } from './qms/tasks-ec-participants/tasks-ec-participants.component';
import { TasksEcDocumentsComponent } from './qms/tasks-ec-documents/tasks-ec-documents.component';
import { MyTasksComponent } from './my-tasks/my-tasks.component';
import { TaskActionsHistoryComponent } from './qms/task-actions-history/task-actions-history.component';
import { OneqmsTopicsComponent } from './oneqms-topics/oneqms-topics.component';
import { CapaComponent } from './qms/capa/capa.component';
import { TmsUserTrainingsReportComponent } from './tms-user-trainings-report/tms-user-trainings-report.component';
import { DocumentExtensionComponent } from './dms-sub-folder/document-extension/document-extension.component';
import { DocumentWithdrawalComponent } from './dms-sub-folder/document-withdrawal/document-withdrawal.component';
import { DvComponent } from './qms/dv/dv.component';
import { InComponent } from './qms/in/in.component';
import { RaiseInComponent } from './qms/raise-in/raise-in.component';
import { RaiseCcComponent } from './qms/raise-cc/raise-cc.component';
import { CcComponent } from './qms/cc/cc.component';
import { TmsUserManageTrainingsReportComponent } from './tms-user-manage-trainings-report/tms-user-manage-trainings-report.component';
import { ScheduledTrainingsComponent } from './scheduled-trainings/scheduled-trainings.component';
import { ScheduledTrainingDetailsComponent } from './scheduled-trainings/scheduled-training-details/scheduled-training-details.component';
import { CcpComponent } from './qms/ccp/ccp.component';
import { AuMasterComponent } from './qms/au/au-master/au-master.component';
import { AuComponent } from './qms/au/au.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AuFindingsComponent } from './qms/au/au-findings/au-findings.component';
import { AuFollowupsComponent } from './qms/au/au-followups/au-followups.component';
import { AuParticipantsComponent } from './qms/au/au-participants/au-participants.component';
import { AuRecommendationsComponent } from './qms/au/au-recommendations/au-recommendations.component';
import { AuDetailPageComponent } from './qms/au/au-detail-page/au-detail-page.component';
import { TmsUserTrainingReviewPeriodComponent } from './tms-user-training-review-period/tms-user-training-review-period.component';
import { AuQuestionsComponent } from './qms/au/au-questions/au-questions.component';
import { BadgeRangesComponent } from './tms/badge-ranges/badge-ranges.component';
import { TaskHistoryComponent } from './qms/task-history/task-history.component';
import { TmsUserTrainingReviewPeriodEditComponent } from './tms-user-training-review-period-edit/tms-user-training-review-period-edit.component';
import { TeamTrainingsComponent } from './training-dashboard/team-trainings/team-trainings.component';
import { AuFindingDetailsComponent } from './qms/au/au-finding-details/au-finding-details.component';
import { AuService } from './qms/au/au.service';
import { InvestigationTechniqueTemplateComponent } from './qms/investigation-technique-template/investigation-technique-template.component';
import { DvParticipantsComponent } from './qms/dv-participants/dv-participants.component';
import { ActivityReportComponent } from './activity-report/activity-report.component';
import { DistributedFolderComponent } from './dms-sub-folder/distributed-folder/distributed-folder.component';
import { QiComponent } from './qms/qi/qi.component';
import { DocumentTagsComponent } from './dms-sub-folder/document-tags/document-tags.component'
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { MoreActivityReportDetailsComponent } from './more-activity-report-details/more-activity-report-details.component';
import { PickQuestionsComponent } from './qms/au/pick-questions/pick-questions.component';
import { QuickAccessComponent } from './quick-access/quick-access.component';
import { SchedulersComponent } from './schedulers/schedulers.component';
import { SchedulersDetailComponent } from './schedulers/schedulers-detail/schedulers-detail.component';
import { OneQmsMoreAdminReportDetailsComponent } from './one-qms-more-admin-report-details/one-qms-more-admin-report-details.component';
import { OneQmsAdminReportComponent } from './one-qms-admin-report/one-qms-admin-report.component';
import { DMSReportsComponent } from './dms-reports/dms-reports.component';
import { RiskComponent } from './qms/risk/risk.component';
import { RiskScaleComponent } from './qms/risk-scale/risk-scale.component';
import { RiskSettingsComponent } from './qms/risk-settings/risk-settings.component';
import { LocationMasterComponent } from './qms/location-master/location-master.component';
import { DmsNotificationSettingsComponent } from './notification-settings/dms-notification-settings/dms-notification-settings.component';
import { TmsNotificationSettingsComponent } from './notification-settings/tms-notification-settings/tms-notification-settings.component';
import { QmsNotificationSettingsComponent } from './notification-settings/qms-notification-settings/qms-notification-settings.component';
import { TaskStageStatisticsComponent } from './qms/task-stage-statistics/task-stage-statistics.component';

import { MsalModule, MsalInterceptor, MsalService, MsalGuard } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { LoginAdComponent } from './login-ad/login-ad.component';

const isIE = globalThis.navigator.userAgent.includes('MSIE ') || globalThis.navigator.userAgent.includes('Trident/');
import { DocumentIssuanceHistoryComponent } from './dms/document-issuance-history/document-issuance-history.component';
import { AfterLoginComponent } from './after-login/after-login.component';
import { DmsSearchDocumentComponent } from './dms-search-document/dms-search-document.component';
import { CreateOrUpgradeOrgComponent } from './organization/create-or-upgrade-org/create-or-upgrade-org.component';
import { RegisterOrgComponent } from './organization/create-or-upgrade-org/register-org/register-org.component';
import { ManageOrganizationComponent } from './organization/manage-organization/manage-organization.component';
import { HomepageComponent } from './homepage/homepage.component';
import { LoginAdTempComponent } from './login-ad-temp/login-ad-temp.component';
import { LoginnonADComponent } from './loginnon-ad/loginnon-ad.component';
import { TrainingCertificateTemplateComponent } from './tms/training-certificate-template/training-certificate-template.component';
import { TmsReportsComponent } from './tms-reports/tms-reports.component';
import { FormTemplatesComponent } from './formsLogsSetup/form-templates/form-templates.component';
import { FormSectionTemplateComponent } from './formsLogsSetup/form-section-template/form-section-template.component';
import { FormTemplateUsersComponent } from './formsLogsSetup/form-template-users/form-template-users.component';
import { FormTemplateFieldsComponent } from './formsLogsSetup/form-template-fields/form-template-fields.component';
import { FormTemplateDetailComponent } from './formsLogsSetup/form-template-detail/form-template-detail.component';
import { FomsLogsImplementationComponent } from './foms-logs-implementation/foms-logs-implementation.component';
import { FormsLogsDetailComponent } from './foms-logs-implementation/forms-logs-detail/forms-logs-detail.component';
import { FileLaunchComponent } from './file-launch/file-launch.component';
import { DmsMainReportComponent } from './dms-main-report/dms-main-report.component';
import { DrModeComponent } from './organization/dr-mode/dr-mode.component';
import { NotificationsComponent } from './qms/notifications/notifications.component';
import { OneqmsInterceptorInterceptor } from './oneqms-interceptor.interceptor';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { TopNavService } from './top-navigation/top-navigation.service';

import { AuditReportFindingDetailComponent } from './audit-report-finding-detail/audit-report-finding-detail.component';
import { OveralldashboardComponent } from './qms/overalldashboard/overalldashboard.component';
import { FindingDueDateComponent } from './finding-due-date/finding-due-date.component';
import { FollowupDueDateComponent } from './followup-due-date/followup-due-date.component';
import { FormsComponent } from './formsLogsSetup/forms/forms.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './calendar/calendar.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { UserNotificationsComponent } from './notifications/notifications.component';
import { QualityDependenciesComponent } from './qms/quality-dependencies/quality-dependencies.component';
import { MatSelectFilterModule } from './mat-select-filter/mat-select-filter.module';
import { OneQMSDashboardComponent } from './one-qms-dashboard/one-qms-dashboard.component';
import { TrainingsConclusiveTrailComponent } from './support/trainings-conclusive-trail/trainings-conclusive-trail.component';
import { SharedModule } from './shared/shared.module';
import { ParallelWorkflowComponent } from './qms/parallel-workflow/parallel-workflow';
import { AddParallelWorkflowsComponent } from './qms/add-parallel-workflows/add-parallel-workflows.component';
import { ParallelWorkflowDetailComponent } from './qms/parallel-workflow/parallel-workflow-detail/parallel-workflow-detail.component';
import { ParallelWorkflowActionsComponent } from './qms/parallel-workflow/parallel-workflow-actions/parallel-workflow-actions.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ParallelWorkflowFindingsComponent } from './qms/parallel-workflow/parallel-workflow-findings/parallel-workflow-findings.component';



import { AppService } from './app.service';
import { dynamiclabelService } from './dynamiclabel.service';
import { FormsAndLogsReportsComponent } from './forms-and-logs-reports/forms-and-logs-reports.component';
import { FormsAndLogsMoreReportsComponent } from './forms-and-logs-more-reports/forms-and-logs-more-reports.component';
import { FeedbackTemplateComponent } from './feedback-template/feedback-template.component';
import { FeedbackTemplateDetailComponent } from './feedback-template/feedback-template-detail/feedback-template-detail.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { UserEventsComponent } from './user-events/user-events.component';
import { HomepagetagComponent } from './homepagetag/homepagetag.component';
import { AddDocumentFromPopupComponent } from './dms/add-document-from-popup/add-document-from-popup.component';
import { VendorDetailsComponent } from './qms/vendor-details/vendor-details.component';
import { SearchUsersComponent } from './qms/search-users/search-users.component';
import { SwitchuserComponent } from './support/switchuser/switchuser.component';
import { DocumentDownloadComponent } from './dms/document-download/document-download.component';
import { DynamicgridComponent } from './support/dynamicgrid/dynamicgrid.component';
import { ActivityAuTrailComponent } from './qms/activity-au-trail/activity-au-trail.component';
import { ModuletypeComponent } from './moduletype/moduletype.component';
import { DocumentHeaderTemplateComponent } from './dms/document-header-template/document-header-template.component';
import { OosComponent } from './qms/oos/oos.component';
import { OosActionsComponent } from './qms/oos/oos-actions/oos-actions.component';
import { ParallelWorkflowOosActionsComponent } from './qms/parallel-workflow/parallel-workflow-oos-actions/parallel-workflow-oos-actions.component';
import { OosQuestionsComponent } from './qms/oos/oos-questions/oos-questions.component';
import { OosLabInvestigationTemplateComponent } from './admin/oos-lab-investigation/oos-lab-investigation-template/oos-lab-investigation-template.component';
import { OosLabInvestigationCategoryComponent } from './admin/oos-lab-investigation/oos-lab-investigation-category/oos-lab-investigation-category.component';
import { ImpactAssessmentTemplateComponent } from './admin/impact-assessment/impact-assessment-template/impact-assessment-template.component';
import { ImpactAssessmentFieldsComponent } from './admin/impact-assessment/impact-assessment-fields/impact-assessment-fields.component';
import { AddMapCapaComponent } from './qms/add-map-capa/add-map-capa.component';
import { ImpactAssessmentComponent } from './qms/impact-assessment/impact-assessment.component';
import { InstrumentMasterComponent } from './admin/instrument-master/instrument-master.component';
import { NoCopyPasteDirective } from './directives/no-copy-paste.directive';
import { PreActionsComponent } from './qms/pre-actions/pre-actions.component';
import { AssignTrainingComponent } from './tms/assign-training/assign-training.component';
import { ChecklistTemplateComponent } from './admin/check-list/checklist-template/checklist-template.component';
import { ChecklistFieldsComponent } from './admin/check-list/checklist-fields/checklist-fields.component';
import { ChecklistComponent } from './qms/checklist/checklist.component';
import { FlexibleFieldsComponent } from './qms/flexible-fields/flexible-fields.component';
import { DocumentDestructionComponent } from "src/app/document-destruction/document-destruction.component";
import { DynamicGridComponent } from './support/dynamic-grid/dynamic-grid.component';
import { GlobalLoaderInterceptor } from './global-loader.interceptor';
import { DocumentDownloadTemplateComponent } from './dms/document-download-template/document-download-template.component';
import { DocumentDestructionsHistoryComponent } from './document-destructions-history/document-destructions-history.component';
import { RequestIssuanceComponent } from './dms-sub-folder/request-issuance/request-issuance.component';
import { TasksEcFindingsComponent } from './qms/tasks-ec-findings/tasks-ec-findings.component';
import { TabLabelComponent } from './support/tab-label/tab-label.component';
import { SessionTimeoutDialogComponent } from './session-timeout-dialog/session-timeout-dialog.component';
import { QualityDependentsComponent } from './qms/quality-dependents/quality-dependents.component';
import { OneQmsFileUploaderComponent } from './support/file-uploader/one-qms-file-uploader/one-qms-file-uploader.component';
import { OrgPrintersComponent } from './admin/org-printers/org-printers.component'
import { firstValueFrom } from 'rxjs';
import { OneQmsAuthService } from './core/auth/one-qms-auth.service';
import { EsignatureSetupComponent } from './esignature-setup/esignature-setup.component';
import { EsignatureSignComponent } from './esignature-sign/esignature-sign.component';
import { SafeUrlPipe } from './esignature-setup/Safe url.pipe';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { LayerFilterPipe } from './esignature-setup/Layer filter.pipe';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { HasUnassignedPipe } from './esignature-setup/has-unassigned.pipe';
import { JsonParsePipe } from './../app/esignature-setup/json-parse.pipe';
import { NgxEchartsModule } from 'ngx-echarts';
import { SimpleChartComponent } from './AST_Charts/simple-chart.component';


export function initializeMsal(service: AppService, msalService: MsalService, messageService: messageService) {

  let APP_URL = !localStorage.getItem("adapplicationUrl") || localStorage.getItem("adapplicationUrl") == "undefined" ? location.href : localStorage.getItem("adapplicationUrl");

  console.log('APP URL → ', APP_URL);

  if (APP_URL == 'http://localhost:4200/login') {
    APP_URL = "https://predev.one-qms.com/login";
  }

  return () => firstValueFrom(
    service.fetchMsalConfig({ applicationUrl: APP_URL })
  ).then((config: any) => {
    if (config && config.resultType != 'E') {
      if (config.adEnabled == 'Y') {
        localStorage.setItem("adapplicationUrl", config.applicationUrl);
        localStorage.setItem("adEnabled", config.adEnabled);
        messageService.setOrgId(config.orgId);
      }

      const tenantId = config.talentId;
      const clientId = config.clientId;
      console.log("TENANT ID", tenantId);

      const msalInstance = new PublicClientApplication({
        auth: {
          clientId: clientId,
          authority: `https://login.microsoftonline.com/${tenantId}`,
          redirectUri: location.origin + '/profile',
        }
      });

      msalService.instance = msalInstance;
    }
  });

}

export function initializeApplication(
  authService: OneQmsAuthService
) {
  return () => authService.initializeAuth();
}
@NgModule({
  declarations: [
    JsonParsePipe,
    HasUnassignedPipe,
    EsignatureSetupComponent,
    EsignatureSignComponent,
    NoCopyPasteDirective,
    DynamicgridComponent,
    AppComponent,
    LoginComponent,
    DashboardComponent,
    TableComponent,
    ConfirmDialogComponent,
    SuccessSnackbarComponent,
    ResetpasswordComponent,
    LeftTreeComponent,
    ManageTrainingComponent,
    AddTrainingComponent,
    ContentDialogComponent,
    AssessmentDialogComponent,
    AssessmentOptionDialogComponent,
    UsersComponent,
    ReorderDialogComponent,
    MenuItemComponent,
    TrainingPreviewComponent,
    GroupsComponent,
    TrainingDashboardComponent,
    LaunchTrainingComponent,
    GroupUsersComponent,
    CodelistComponent,
    QuizComponent,
    QuizItemComponent,
    TrainingParameterTemplateComponent,
    DocumentTemplateComponent,
    ReasonForSignatureTemplateComponent,
    TrainingReviewPeriodComponent,
    QmsSettingsVwComponent,
    TmsSettingsComponent,
    ProductCountriesComponent,
    VendorsComponent,
    DmsSettingsComponent,
    ProductMasterComponent,
    DocumenttypeComponent,
    QmsgroupsComponent,
    GroupDetailsComponent,
    GroupusersComponent,
    CRComponent,
    ActivityDynamicButtonComponent,
    ActivityGridComponent,
    TmsGroupsComponent,
    TmsGroupDetailComponent,
    TmsGroupUsersComponent,
    TmsGroupTrainingsComponent,
    QmsReportTemplateComponent,
    StageusersComponent,
    QmsReporttemplateSectionfieldComponent,
    TrainingDashboardDetailComponent,
    TaskDocumentsComponent,
    QmsQuestionnaireTemplateComponent,
    QmsQuestionnaireTemplateQuestionComponent,
    DmsRootFolderComponent,
    DmsSubFolderComponent,
    AddDocumentComponent,
    OneqmsOrganizationComponent,
    TaskExtensionsComponent,
    ActionsComponent,
    QmsBusinessareaComponent,
    TasksEcComponent,
    TasksEcActionsComponent,
    TasksEcParticipantsComponent,
    TasksEcDocumentsComponent,
    MyTasksComponent,
    TaskActionsHistoryComponent,
    OneqmsTopicsComponent,
    CapaComponent,
    TmsUserTrainingsReportComponent,
    DocumentExtensionComponent,
    DocumentWithdrawalComponent,
    DvComponent,
    InComponent,
    RaiseInComponent,
    RaiseCcComponent,
    CcComponent,
    TmsUserManageTrainingsReportComponent,
    ScheduledTrainingsComponent,
    ScheduledTrainingDetailsComponent,
    CcpComponent,
    AuMasterComponent,
    AuComponent,
    CcpComponent,
    AuFindingsComponent,
    AuFollowupsComponent,
    AuParticipantsComponent,
    AuRecommendationsComponent,
    AuDetailPageComponent,
    AuQuestionsComponent,
    BadgeRangesComponent,
    TmsUserTrainingReviewPeriodComponent,
    AuQuestionsComponent,
    TaskHistoryComponent,
    TmsUserTrainingReviewPeriodEditComponent,
    TeamTrainingsComponent,
    AuFindingDetailsComponent,
    InvestigationTechniqueTemplateComponent,
    DvParticipantsComponent,
    ActivityReportComponent,
    DistributedFolderComponent,
    QiComponent,
    DocumentTagsComponent,
    MoreActivityReportDetailsComponent,
    PickQuestionsComponent,
    QuickAccessComponent,
    SchedulersComponent,
    SchedulersDetailComponent,
    OneQmsMoreAdminReportDetailsComponent,
    DMSReportsComponent,
    RiskComponent,
    OneQmsAdminReportComponent,
    RiskScaleComponent,
    RiskSettingsComponent,
    LocationMasterComponent,
    DmsNotificationSettingsComponent,
    TmsNotificationSettingsComponent,
    QmsNotificationSettingsComponent,
    TaskStageStatisticsComponent,
    LoginAdComponent,
    DocumentIssuanceHistoryComponent,
    AfterLoginComponent,
    DmsSearchDocumentComponent,
    CreateOrUpgradeOrgComponent,
    RegisterOrgComponent,
    ManageOrganizationComponent,
    HomepageComponent,
    LoginAdTempComponent,
    LoginnonADComponent,
    TrainingCertificateTemplateComponent,
    TmsReportsComponent,
    FormTemplatesComponent,
    FormSectionTemplateComponent,
    FormTemplateUsersComponent,
    FormTemplateFieldsComponent,
    FormTemplateDetailComponent,
    FomsLogsImplementationComponent,
    FormsLogsDetailComponent,
    FileLaunchComponent,
    DmsMainReportComponent,
    DrModeComponent,
    NotificationsComponent,
    TopNavigationComponent,
    AuditReportFindingDetailComponent,
    OveralldashboardComponent,
    FindingDueDateComponent,
    FollowupDueDateComponent,
    FormsComponent,
    CalendarComponent,
    UserNotificationsComponent,
    QualityDependenciesComponent,
    OneQMSDashboardComponent,
    TrainingsConclusiveTrailComponent,
    //SettingsComponent,
    ParallelWorkflowComponent,
    AddParallelWorkflowsComponent,
    ParallelWorkflowDetailComponent,
    ParallelWorkflowActionsComponent,
    ParallelWorkflowOosActionsComponent,
    ParallelWorkflowFindingsComponent,
    FormsAndLogsReportsComponent,
    FormsAndLogsMoreReportsComponent,
    FeedbackTemplateComponent,
    FeedbackTemplateDetailComponent,
    UserEventsComponent,
    HomepagetagComponent,
    AddDocumentFromPopupComponent,
    VendorDetailsComponent,
    SearchUsersComponent,
    DocumentDownloadComponent,
    ActivityAuTrailComponent,
    ModuletypeComponent,
    DocumentHeaderTemplateComponent,
    OosComponent,
    OosActionsComponent,
    OosQuestionsComponent,
    OosLabInvestigationTemplateComponent,
    OosLabInvestigationCategoryComponent,
    ImpactAssessmentTemplateComponent,
    ImpactAssessmentFieldsComponent,
    AddMapCapaComponent,
    ImpactAssessmentComponent,
    InstrumentMasterComponent,
    NoCopyPasteDirective,
    PreActionsComponent,
    AssignTrainingComponent,
    ChecklistTemplateComponent,
    ChecklistFieldsComponent,
    ChecklistComponent,
    FlexibleFieldsComponent,
    DynamicGridComponent,
    DocumentDownloadTemplateComponent,
    RequestIssuanceComponent,
    RequestIssuanceComponent,
    DocumentDestructionsHistoryComponent,
    TasksEcFindingsComponent,
    TabLabelComponent,
    SessionTimeoutDialogComponent,
    QualityDependentsComponent,
    OneQmsFileUploaderComponent,
    OrgPrintersComponent,
    SafeUrlPipe,
    LayerFilterPipe
  ],

  imports: [
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    CommonModule,
    SimpleChartComponent,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    MatSnackBarModule,
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    MatSidenavModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    HttpClientModule,
    MatMenuModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatTableModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatBadgeModule,
    MatToolbarModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    FontAwesomeModule,
    AngularEditorModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    NgxPaginationModule,
    MatFormFieldModule,
    FullCalendarModule,
    NgIdleKeepaliveModule.forRoot(),
    NgCircleProgressModule.forRoot(),
    MatProgressBarModule,
    CanvasJSAngularChartsModule,
    HighchartsChartModule,
    MatSelectFilterModule,
    SharedModule,
    ColorPickerModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: '',
        authority: '',
        redirectUri: '', // Adjust to your app's URL
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      }
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    }),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    DocumentDestructionComponent
  ],

  exports: [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatToolbarModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    MatToolbarModule,
    MatTableModule,
    MatIconModule,
    AngularEditorModule,
    MatSelectFilterModule,
    NgxPaginationModule,
    SafeUrlPipe,
    LayerFilterPipe
  ],

  providers: [
    ActivityGridComponent,
    AuComponent,
    AuDetailPageComponent,
    AuFindingsComponent,
    AuFollowupsComponent,
    AuParticipantsComponent,
    AuRecommendationsComponent,
    CcComponent,
    TaskDocumentsComponent,
    CRComponent,
    CapaComponent,
    DatePipe,
    DvComponent,
    DvParticipantsComponent,
    Idle,
    InComponent,
    PaginationService,
    QiComponent,
    RiskScaleComponent,
    TaskActionsHistoryComponent,
    TasksEcComponent,
    messageService,
    qmsService,
    AuQuestionsComponent,
    MsalService,
    TopNavService,
    QualityDependenciesComponent,
    ParallelWorkflowComponent,
    ParallelWorkflowFindingsComponent,
    dynamiclabelService,
    SwitchuserComponent,
    OosComponent,
    RiskComponent,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApplication,
      deps: [OneQmsAuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [AppService, MsalService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    }, MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OneqmsInterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalLoaderInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        // Redirect HTTP to HTTPS in production
        if (location.protocol === 'http:'
          && !location.hostname.includes('localhost')) {
          location.href = location.href.replace('http:', 'https:');
        }
      },
      multi: true
    }

  ],
  bootstrap: [
    AppComponent
  ]

})

export class AppModule { }
